var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#171796",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v26.7H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M.7 0H54v13.3H.7zm26.6 30.3c4.3 0 7.8-3.5 7.8-7.7v-9.3H19.6v9.3c0 4.3 3.5 7.8 7.7 7.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.3 30.2a7.7 7.7 0 0 0 7.7-7.6v-9.1H19.7v9a7.7 7.7 0 0 0 7.6 7.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M23 13.8h-3V17h3zm0 6.4h2.9V17h-3zm-3 2.4v.8h3v-3.2h-3zm8.8-2.4h-3v3.2h3zm0 6.5h3v-3.3h-3zm3 1.7q1-.7 1.6-1.7h-1.6zm-8.9-1.7h3v-3.3h-3zm-1.6 0q.6 1 1.6 1.7v-1.7zm6.5 3.2 1-.1v-3.1h-3v3zm6.8-6.5v-3.2h-2.9v3.2zm-5.8-3.2h3V17h-3zm0-6.4h-3V17h3zm5.9 3.2v-3.2h-3V17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m34.8 13.2 1.9-4-1.4-2.3-2.3.8L31.4 6l-2.2 1-1.9-1.6L25.4 7l-2-1.2-1.7 1.8-2.3-.8L18 9l1.8 4.1a18 18 0 0 1 15 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0093dd",
    d: "m21.8 7.9-2.3-.8-1.3 2 .5 1.1 1.2 2.8 2.9-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.6 10 .1.5a1.1 1.1 0 0 1-2.2.2 1.1 1.1 0 0 0 2.1-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m19.6 9.5.1-.4-.3-.3.4-.1v-.4l.4.2.4-.1v.4l.2.3-.4.1v.4l-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7db17",
    d: "m20.1 9 .3.2.4-.1zm0 0h.7l-.3-.2zm-.7-.2.7.1-.3-.2zm.7.2-.7-.2.3.3zm0 0 .5-.6-.4.2zm-.4.5L20 9h-.4zM20 9l-.4.5.3-.2zm.5-.6L20 9h.4zM20 9l-.2-.6v.4zm.2.7-.2-.6v.4zm-.2-.6.2.6.1-.4zm-.2-.7.2.6v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171796",
    d: "M25.5 7.3 23.3 6l-1.6 1.8 1.1 4.1 3-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m22.5 11 3.2-.5v-1q-1.8 0-3.4.5zM22 9q1.8-.6 3.6-.7l-.1-1q-2 0-3.7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0093dd",
    d: "m29.2 7.3-1.9-1.6-1.8 1.6.3 4.2h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.3 9.2v.2h-.1v.1H27l-.1-.1h-.1v.2h.1v.1h-.2l.1.3h-.1l.1.2v.2q-.2 0 0 0v.2h.2v.1h.1v.1h.4v-.1h.3v-.3h.2v-.1l-.1-.1.1-.2v-.3h-.1v-.1l.2-.3H28l-.2.1-.1.1-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7db17",
    d: "M26.9 9.6h.9v-.1l.1-.2-.1.1-.2.1h-.1v-.1l-.2-.2v.2h-.1v.1H27l-.1-.1h-.2.1q.2.1 0 .1zm.9.2h-1v.1-.1l.1.1-.1-.1v.2h.1-.1v.1h-.1.2l-.1.2h.1-.1.2v.1h-.1v.1-.1.1h.1-.1.1v.2-.1h.1-.1.1v.1-.1h.1v.2-.1h.1v.1-.1.1h.1v-.1h.1v.1-.2l.2.1h-.1.1a.1.1 0 0 0-.1-.2v.1h.2v-.1h-.1.1v-.1h-.1l.1.1v-.1h-.1.2v-.1h-.1.1v-.1h-.1l.2-.2h-.1v.1h-.1V10l.2-.3zm0-.1h-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7db17",
    fillRule: "evenodd",
    d: "M27 9.7h.7zm.1 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.3 9.5h.1m-.1 1h.1v-.2h.1v.2zm0 0h.2zm.2-.5.2-.1zm-.1 0h-.1v-.1zm0-.2v.3h-.1l-.3.1h.2zm0 .2h-.1zm0-.2v.2h.4-.2v.1h-.1zm.3.2h-.1v.1zm-1.2-2.7-.1.1-.1.2q0-.1-.2 0v-.2h-.2l.1.3v.1h-.1v.6h.2v.4h.2v.1l.2-.1V9h.2v-.2h.2v-.1h.1v-.2h.2v-.1l-.2-.1q.2 0 .2-.2H27l.1-.3h-.2l.2-.3h-.2l-.2.2v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7db17",
    d: "M26 7.6h1v-.3h-.1v.1h-.2q0 .1 0 0h-.1l-.1-.2-.1.1v.1h-.1v.1h-.2l-.1-.1h-.1.1zm1 .1h-1.1V8h.1v-.1h-.1V8h.1v.1h-.1.1-.1l.1.1h.1l-.2.2h.1v-.1.2h.1v.1h.1-.1.1v.2-.2h.1l-.1.1h.1V9v-.2.1h.1v-.1l.1.1V9l.1-.1v-.1.1-.1l.1.1v-.1h.2-.1.1l-.1-.1v.1h.1v-.1h.1l-.1-.1h.1-.1.1l-.1-.1h.2-.1.1v-.1H27v-.1l.2-.2-.1.1H27h.1-.1V8l.1-.2V8H27zV8zh.1zm-.1 0h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7db17",
    fillRule: "evenodd",
    d: "M26.1 7.8h.8v-.1zm.2-.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26.7 8.5h-.1m0 0h-.1zm-.4 0h.2zm0 0h.2zm.1.1h.1v-.1zh.2v.2zm0 0h.1m.2-.6h.1zm-.2-.1v.2h-.2l-.1-.1zm.2 0h.2V8zm1.6-.6-.1.1-.1.2-.2-.1-.1-.1h-.1l.1.2v.2h-.1V8h-.1q0 .2.2.2l-.1.1v.1h.1v.3h.2V9l.2-.1V9h.2v-.1h.3v-.3h.2v-.1l-.1-.2.2-.1h-.2l.1-.3h-.2v-.1l.2-.3h-.1l-.1.1h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7db17",
    d: "M27.8 7.6h.9l.1-.2h-.1v.1h-.1l-.2.1v-.1l-.2-.2-.1.1v.1H28q0 .1 0 0zl-.2-.1v.1zm.8.2h-.2l-.1-.1h-.7V8h.1v-.1.2-.2h-.1V8h.1v.1h-.2.2-.2l.2.1h.1-.1v.1h-.1v.1h.1-.1.2v.1h-.1.1-.1.1l-.1.1h.1v.1l.1-.1v.1h-.1.2V9v-.2.1-.1h.1V9l.1-.1h.1v-.1h.2-.1v-.1l.1.1v-.1h.1-.1.1v-.1h-.1.2v-.2l.1-.2h-.1.1-.2.1l.1-.3V8h-.2l.1-.1.1-.1zm0 0h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7db17",
    fillRule: "evenodd",
    d: "M27.8 7.8h.8v-.1zm.2-.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M28 8.5h.1zm0 0 .1.1v-.2h.1v.2zm.2-.5h.2zm0 0H28zM28 8l-.1-.1zl.1.1zm.1 0h.2l.1-.1V8zm.2.2h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171796",
    d: "m33 8-1.7-2-2 1.3-.4 4.2 3 .5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29.6 8.2h.4l.2-.1h.8l.2.1h.4v.1q-.4.2-.7 0l.2.1.3.2h.4v.1h-.7l-.2-.2-.3-.2h-.2l.2.1-.2.1h-.1v.3h.1V9h.4l.2.2h1.1l-.2.1v.2h-.2v.6h-.1v.2h-.2l-.1.3h-.1v.2h-.3v-.1l.2-.2.1-.2v-.1h-.3v.1l-.2.1v.1h-.1v.2h-.2v-.1l.2-.2.1-.1V10h-.4v.2h-.1v.2H30v.2h-.2v-.2l.1-.2v-.1l.1-.2v.2h-.1v.2h-.3l.1-.2.1-.1v-.6q-.2 0 0-.1v-.6h-.1v-.1q-.2 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7db17",
    d: "M31 10.2h-.1l-.2.2v.1h-.1v.1h-.2l.2-.2.1-.1V10h.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7db17",
    d: "M29.8 9.4q-.2 0 0 0v.6l-.1.1-.2.1v.1h.2V10h.2v-.2l.1-.1v.6l-.1.2-.2.1h.1v.1h.2v-.1l.1-.1v-.1l.1-.2V10h.1v-.2.1h.1l.1-.1v.1l.2-.1-.1.1h.2v-.2h.1v.1h-.1v.1h.1v-.1.1h.1v.2-.1h.2v.1q.2 0 0 0v.1l-.1.3H31v.1h-.2.1v.1h.2v-.1l.1-.1.2-.2v-.1h.1v-.1h.1v-.5h.1v-.2h.1v-.1h.1l.1-.1h-.5v-.1h-.1v.1l-.1-.1h-.1v.2-.2H31v.1-.1.1-.1h-.1V9h-.2v.1V9h-.1v.1V9l-.1-.1-.1-.1h-.1v-.2h-.1v-.1H30h.1q0-.2.1 0h.1l.1-.1h-.1.1v-.1h-.3.3v-.2h-.3v.1H30l.2-.1h-.3v.1l-.1.1-.1.1v.2h.2v.2-.1h.2-.1l-.1.2.1-.1-.1.1v.2h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7db17",
    d: "M29.8 8.3h-.1v-.1zh.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M31.3 10.5h-.1m.1-.8v.2a.1.1 0 0 0 .1-.2v.2zm0 .2v.2zm0 0v.2zm.1 0v.2zm-.1-.5v.3-.1.1zm-.3 0v.3h.1v-.2.2-.2m-.1-.2-.1.1v.1zh-.1v.1zm.1.3v.2zm-.4-.4h.1v.1zm0 .2v.2zm-.2 0v.2zm-.4.2v.2h.1zm.1-.2q.2 0 0 .1zm0-.1v.2zm.2-.5V9zM30 9v.3l-.1-.1zm.2 0H30v.2V9zm.4.4v.2zm0 .2h-.2v.2-.3.2zm-.5.1v-.3zm.2-.4v.2zm-.3.1-.1.1zm.2-.2v.2zm-.3-.8h.2zh.2zm.1-.5h-.1m-.3 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M31.4 8.3h.2zm-1-.3h.2v.1h.4v.1h.1v.1h.2-.4l-.2-.1h-.2zm-.2 0h.2v.1zm.6.4h-.3v-.2h.3zh.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M31 8.5h-.1v-.1zm.2.1-.2-.2h.3zm.2 0h-.2zm.4 0h-.4zm-.8 2h-.2zh.2zm-1.3-.4h-.1v.1zm.8.3h-.1zm-.6 0h.2v-.1zm.3-2.3h.3v-.1H30v.1zm-.2 0 .2-.1h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0093dd",
    d: "m34.8 13 1.7-3.9-1.3-2-2.3.8-1 4.2q1.5.3 2.9 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m32.6 9.4 3.3 1.2-.7 1.5q-1.5-.7-3-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m35.3 11.8.4-1-3.2-1.1-.3 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M32.8 10.5h.2v-.2h-.1l-.2-.1V10h.4v.2h.1l.4.3h.4q.5 0 .6.2h.3l.3.1.2.1v.1H35l-.2-.1h-.1v.2h.1v.2h.1l-.1.1h-.1v-.2l-.2-.1-.2-.1h-.5.2v-.1h-.8l-.1-.1q0-.2 0 0h.2v-.1l-.1-.1h-.5v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.1 10.9h-.2l-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M34.3 7.9v.4l-.3.3.4.1v.4h.1l.3-.2.4.1v-.4l.3-.3-.4-.1-.1-.4-.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7db17",
    d: "m34 8.6.3-.3.4.1zm.8-.2.2-.2.4.1zm.6 0-.3.2-.3-.1zm-.7 0-.3.3-.3-.1zm-.4-.5.4.1v.4zm.5.6h.3V9zm.4.5-.4-.2v-.3zm-.5-.6h-.4v-.5zm.3-.6v.4l-.2.2zm-.3.7.1.4-.3.2zm-.2.6v-.4l.2-.2zm.2-.7V8l.3-.2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/hr.038f238a6c3dd943b8a9528769023de6.svg";
export { ForwardRef as ReactComponent };